// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-screen[data-v-8b6cf6cc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: clamp(1rem, 1.8vw, 1.5rem);\n}\n.panel-screen__pair[data-v-8b6cf6cc] {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: clamp(1rem, 1.8vw, 1.5rem);\n}\n", ""]);
// Exports
module.exports = exports;
